export class ValidationError {
  [key: string] : string[];
}
